import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../../../app/components/Table';
import Pagination from '../../../app/components/Pagination';
import Input from '../../../app/components/Input';
import Button from '../../../app/components/Button';
import { FiEdit, FiPlus } from 'react-icons/fi';
import OffCanvas from '../../../app/components/OffCanvas';
import AcessAdd from '../../../forms/CustomerDetailForm/AccessAdd';
import ContactsAdd from '../../../forms/CustomerDetailForm/ContactsAdd';
import ClienteOffCanvas from './ClientesOffCanvas'
import Toast from '../../../app/components/Toast';
import DeletAcessForm from '../../../forms/FormClient/DeleteAcessForm';
import FormRegister from '../../../forms/FormRegisterClient';
import { AnimatePresence } from "framer-motion";
import Tabs from '../../../app/components/Tabs';
import { usePageTitle } from '../../../contexts/PageTitleContext';

const Clientes = () => {
  const { setTitle } = usePageTitle();
  
  useEffect(() => {
    setTitle('Clientes');
  }, [setTitle]); 

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
  const [activeTab, setActiveTab] = useState('register');
  const [showAcessAdd, setShowAcessAdd] = useState(false);
  const [showContactsAdd, setShowContactsAdd] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [toastData, setToastData] = useState(null);
  const [accessByCompany, setAccessByCompany] = useState({});
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [contactsByCompany, setContactsByCompany] = useState({});
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showDeleteClientModal, setShowDeleteClientModal] = useState(false);
  const [showDeleteAccessContactModal, setShowDeleteAccessContactModal] = useState(false);
  const [activeCompaniesTab, setActiveCompaniesTab] = useState('ativos');


  const itensPorPagina = 10;
  const itemsByPages = itensPorPagina;

  const [empresas, setEmpresas] = useState([
    { id: 1, cnpj: '12.345.678/0001-90', regimeTributario: 'Simples Nacional', nomeFantasia: 'Empresa Alpha', grupo:'Geral', razaoSocial: 'Empresa Alpha LTDA', cidade: 'São Paulo', uf: 'SP', churn:'churn', status: 'ativo', prontuario: true },
    { id: 2, cnpj: '98.765.432/0001-10', regimeTributario: 'Lucro Presumido', nomeFantasia: 'Empresa Beta', grupo:'Geral', razaoSocial: 'Empresa Beta LTDA', cidade: 'Rio de Janeiro', uf: 'RJ', churn:'churn', status: 'ativo', prontuario: true },
    { id: 3, cnpj: '98.765.432/0001-10', regimeTributario: 'Lucro Presumido', nomeFantasia: 'Empresa Beta', grupo:'Geral', razaoSocial: 'Empresa Beta LTDA', cidade: 'Rio de Janeiro', uf: 'RJ', churn:'churn', status: 'ativo', prontuario: true },
    { id: 4, cnpj: '98.765.432/0001-10', regimeTributario: 'Lucro Presumido', nomeFantasia: 'Empresa Beta', grupo:'Geral', razaoSocial: 'Empresa Beta LTDA', cidade: 'Rio de Janeiro', uf: 'RJ', churn:'não churn', status: 'ativo', prontuario: true },
    { id: 5, cnpj: '98.765.432/0001-10', regimeTributario: 'Lucro Presumido', nomeFantasia: 'Empresa Beta', grupo:'Geral', razaoSocial: 'Empresa Beta LTDA', cidade: 'Rio de Janeiro', uf: 'RJ', churn:'churn', status: 'inativo', prontuario: true },
    { id: 6, cnpj: '98.765.432/0001-10', regimeTributario: 'Lucro Presumido', nomeFantasia: 'Empresa Beta', grupo:'Geral', razaoSocial: 'Empresa Beta LTDA', cidade: 'Rio de Janeiro', uf: 'RJ', churn:'churn', status: 'inativo', prontuario: true },
    { id: 7, cnpj: '98.765.432/0001-10', regimeTributario: 'Lucro Presumido', nomeFantasia: 'Empresa Beta', grupo:'Geral', razaoSocial: 'Empresa Beta LTDA', cidade: 'Rio de Janeiro', uf: 'RJ', churn:'churn', status: 'inativo', prontuario: true },
    { id: 8, cnpj: '98.765.432/0001-10', regimeTributario: 'Lucro Presumido', nomeFantasia: 'Empresa Beta', grupo:'Geral', razaoSocial: 'Empresa Beta LTDA', cidade: 'Rio de Janeiro', uf: 'RJ', churn:'churn', status: 'inativo', prontuario: true },
    { id: 9, cnpj: '98.765.432/0001-10', regimeTributario: 'Lucro Presumido', nomeFantasia: 'Empresa Beta', grupo:'Geral', razaoSocial: 'Empresa Beta LTDA', cidade: 'Rio de Janeiro', uf: 'RJ', churn:'churn', status: 'inativo', prontuario: true },
    { id: 10, cnpj: '98.765.432/0001-10', regimeTributario: 'Lucro Presumido', nomeFantasia: 'Empresa Beta', grupo:'Geral', razaoSocial: 'Empresa Beta LTDA', cidade: 'Rio de Janeiro', uf: 'RJ', churn:'churn', status: 'inativo', prontuario: true },
  ]);

  useEffect(() => {
    OffCanvas.init();
    
    return () => {
    };
  }, []);

  const handlePageChange = (page) => setPaginaAtual(page);
  
  const handleProntuarioClick = (empresa) => navigate(`/record?id=${empresa.id}`);
  
  const handleRowClick = (empresa) => {
    setEmpresaSelecionada(empresa);
    setSelectedCompany(empresa);
    OffCanvas.open(empresa);
  };
  
  const handleCloseOffCanvas = () => {
    setEmpresaSelecionada(null);
    setSelectedCompany(null);
    setShowAcessAdd(false);
    setShowContactsAdd(false); 
  };

  const handleDeleteAcesso = (acessoId) => {
    if (!selectedCompany) return;
    const empresaId = selectedCompany.id;

    setAccessByCompany((prev) => ({
      ...prev,
      [empresaId]: (prev[empresaId] || []).filter((acesso) => acesso.id !== acessoId)
    }));
  };

  const handleDeleteContact = (contactId) => {
    if (!selectedCompany) return;
    const empresaId = selectedCompany.id;

    setContactsByCompany((prev) => ({
      ...prev,
      [empresaId]: (prev[empresaId] || []).filter((contact) => contact.id !== contactId)
    }));
  };

const confirmDeleteAccessContact = () => {
  if (!itemToDelete) return;

  if (itemToDelete.tipo === 'contato') {
    handleDeleteContact(itemToDelete.id);
    setToastData({ type: 'success', message: 'Contato excluído com sucesso!' });
  } else {
    handleDeleteAcesso(itemToDelete.id);
    setToastData({ type: 'success', message: 'Acesso excluído com sucesso!' });
  }

  setShowDeleteAccessContactModal(false);
};



 const openDeletModal = (item, tipo) => {
  setItemToDelete({ ...item, tipo });
  if (item.cnpj) {
    setShowDeleteClientModal(true);
  } else {
    setShowDeleteAccessContactModal(true);
  }
};

  const handleAddAcess = (acesso) => {
    if (!selectedCompany) return;
    
    const novoAcesso = {
      id: Date.now(),
      ...acesso
    };
    
    setAccessByCompany((prev) => ({
      ...prev,
      [selectedCompany.id]: [...(prev[selectedCompany.id] || []), novoAcesso]
    }));
    
    setShowAcessAdd(false);
    setToastData({
      type: 'success',
      message: 'Acesso adicionado com sucesso!'
    });
  };

  const handleUpdateEmpresaField = (campo, novoValor) => {
  if (!empresaSelecionada) return;

  const empresaId = empresaSelecionada.id;

  setEmpresas((prevEmpresas) =>
    prevEmpresas.map((empresa) =>
      empresa.id === empresaId ? { ...empresa, [campo]: novoValor } : empresa
    )
  );

  setEmpresaSelecionada((prev) => ({ ...prev, [campo]: novoValor }));
  setSelectedCompany((prev) => ({ ...prev, [campo]: novoValor }));
};


  const handleAddContacts = (contacts) => {
    if (!selectedCompany) return;
    
    const novoContacts = {
      id: empresas.length ? Math.max(...empresas.map(e => e.id)) + 1 : 1,
      ...contacts
    };
    
    setContactsByCompany((prev) => ({
      ...prev,
      [selectedCompany.id]: [...(prev[selectedCompany.id] || []), novoContacts]
    }));

    
    setShowContactsAdd(false)
    setToastData({
      type: 'success',
      message: 'Contato adicionado com sucesso!'
    });
  };

  const empresasFiltradas = empresas.filter((empresa) => {
    const termo = searchTerm.toLowerCase();
    return (
      empresa.razaoSocial.toLowerCase().includes(termo) ||
      empresa.regimeTributario.toLowerCase().includes(termo) ||
      empresa.cnpj.toLowerCase().includes(termo) ||
      empresa.nomeFantasia.toLowerCase().includes(termo) ||
      empresa.grupo.toLowerCase().includes(termo) ||
      empresa.cidade.toLowerCase().includes(termo) ||
      empresa.uf.toLowerCase().includes(termo)
    );
  });

  const empresasAtivas = empresasFiltradas.filter(e => e.status === 'ativo');
  const empresasInativas = empresasFiltradas.filter(e => e.status === 'inativo');
  
  const empresasFiltradasPorAba = activeCompaniesTab === 'ativos' ? empresasAtivas : empresasInativas;
  const totalPages = Math.ceil(empresasFiltradasPorAba.length / itemsByPages);
  const indiceInicial = (paginaAtual - 1) * itemsByPages;
  const indiceFinal = indiceInicial + itemsByPages;
  const empresasPaginadas = empresasFiltradasPorAba.slice(indiceInicial, indiceFinal);

  

  const getActionsForCliente = (cliente) => {
    if (cliente.status === 'ativo') {
      return [
        {
          icon: FiEdit,
          label: 'Editar',
          onClick: () => handleRowClick(cliente),
        },
      ];
    } else {
      return [
        {
          icon: FiEdit,
          label: 'Editar',
          onClick: () => handleRowClick(cliente),
        },
      ];
    }
  };

  
  const empresasComAcoes = empresasPaginadas.map((item) => ({
    ...item,
    acoes: getActionsForCliente(item)
  }));



  const colluns = [
    { titulo: 'ID', campo: 'id' },
    { titulo: 'CNPJ', campo: 'cnpj' },
    { titulo: 'REGIME TRIBUTÁRIO', campo: 'regimeTributario', apenasDesktop: true },
    { titulo: 'RAZÃO SOCIAL', campo: 'razaoSocial' },
    { titulo: 'GRUPO', campo: 'grupo' },
    { titulo: 'CIDADE', campo: 'cidade', apenasDesktop: true },
    { titulo: 'UF', campo: 'uf' },
    { titulo: 'STATUS', campo: 'status', tipo: 'status' },
    { titulo: 'CHURN', campo: 'churn', tipo: 'churn' },
    {
      titulo: 'PRONTUÁRIO',
      campo: 'prontuario',
      tipo: 'prontuario',
      centralizado: true,
      apenasDesktop: true,
      onClick: (empresa) => handleProntuarioClick(empresa),
    },
    { titulo: 'AÇÕES', campo: 'acoes', tipo: 'acoes', centralizado: true, },
  ];

  const renderizarStatus = (status) => (
    <span
      className={`px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full text-xs font-medium ${
        status === 'ativo' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
      }`}
    >
      {status === 'ativo' ? 'Ativo' : 'Inativo'}
    </span>
  );

  const renderizarChurn = (churn) => (
    <span
      className={`px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full text-xs font-medium ${
        churn === 'sim' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
      }`}
    >
      {churn === 'sim' ? 'sim' : 'nao'}
    </span>
  );

  const renderizarProntuario = (temProntuario, empresa) => (
    <div
      className="cursor-pointer flex justify-center"
      onClick={() => handleProntuarioClick(empresa)}
    >
      <div className={`w-3 h-3 rounded-full ${temProntuario ? 'bg-green-500' : 'bg-gray-300'}`} />
    </div>
  );

  const handleStatusChange = (novoStatus) => {
    if (!empresaSelecionada) return;

    const empresaId = empresaSelecionada.id;

    setEmpresas((prevEmpresas) =>
      prevEmpresas.map((empresa) =>
        empresa.id === empresaId
          ? { ...empresa, status: novoStatus }
          : empresa
      )
    );

    setEmpresaSelecionada((prev) => ({ ...prev, status: novoStatus }));
    setSelectedCompany((prev) => ({ ...prev, status: novoStatus }));
    setActiveCompaniesTab(novoStatus === 'ativo' ? 'ativos' : 'inativos');
  };

  return (
    <>
    <div>
      <div className="flex flex-row items-stretch w-full gap-2 justify-between mb-10 mt-8">
        <Button
          className="flex items-center justify-center h-9 w-9 !px-5 sm:h-auto sm:w-auto sm:px-6"
          onClick={() => setShowRegisterModal(true)}
        >
          <span className="sm:hidden"><FiPlus size={17}/></span>
          <span className="hidden sm:inline">Novo Cliente</span>
        </Button>
        
        <Input
          type="text"
          size="xs"
          variant="search"
          value={searchTerm}
          label="Pesquisar"
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1"
        />
      </div>


      <Tabs
        tabsName={['Ativos', 'Inativos']}
        align='left'
        activeTabName={activeCompaniesTab === 'ativos' ? 'Ativos' : 'Inativos'}
        onTabClick={(tabName) => {
          setActiveCompaniesTab(tabName === 'Ativos' ? 'ativos' : 'inativos');
          setPaginaAtual(1);
        }}
      />

      <div className="overflow-x-auto -mx-3 sm:mx-0 mt-8">
        <Table
          colunas={colluns}
          dados={empresasComAcoes}
          renderizarStatus={renderizarStatus}
          renderizarChurn={renderizarChurn}
          renderizarProntuario={renderizarProntuario}
        />
      </div>

      {empresasFiltradas.length > 0 && (
        <Pagination
          currentPage={paginaAtual}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          showPageNumbers={true}
          maxPageNumbers={5}
        />
      )}

      <ClienteOffCanvas
        isOpen={!!empresaSelecionada}
        onClose={handleCloseOffCanvas}
        empresaSelecionada={empresaSelecionada}
        selectedCompany={selectedCompany}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        handleStatusChange={handleStatusChange}
        contactsByCompany={contactsByCompany}
        accessByCompany={accessByCompany}
        setShowAcessAdd={setShowAcessAdd}
        setShowContactsAdd={setShowContactsAdd}
        openDeletModal={openDeletModal}
        handleUpdateEmpresaField={handleUpdateEmpresaField}
      />


      <AnimatePresence>
        {showAcessAdd && (
          <div className="fixed top-0 ml-[460px] h-full z-50">
            <AcessAdd
              isOpen={true}
              onClose={() => setShowAcessAdd(false)}
              onSave={handleAddAcess}
            />
          </div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showContactsAdd && (
          <div className="fixed top-0 ml-[460px] h-full z-50">
            <ContactsAdd
              isOpen={true}
              onClose={() => setShowContactsAdd(false)}
              onSave={handleAddContacts}
            />
          </div>
        )}
      </AnimatePresence>

    </div>
    {toastData && (
      <Toast
        type={toastData.type}
        message={toastData.message}
        onClose={() => setToastData(null)}
        position="top-right"
      />
    )}

    <DeletAcessForm
      isOpen={showDeleteAccessContactModal}
      onClose={() => setShowDeleteAccessContactModal(false)}
      onConfirm={confirmDeleteAccessContact}
      item={itemToDelete}
      itemLabel={itemToDelete?.tipo === 'contato' ? 'contato' : 'acesso'}
    />


    <FormRegister
      isOpen={showRegisterModal}
      onClose={() => setShowRegisterModal(false)}
      onSave={(novoCliente) => {
        const novoId = empresas.length ? Math.max(...empresas.map(e => e.id)) + 1 : 1;
        const novoComId = {
          id: novoId,
          ...novoCliente,
          prontuario: false,
          status: 'ativo'
        };
        setEmpresas((prev) => [...prev, novoComId]);
        setToastData({ type: 'success', message: 'Cliente cadastrado com sucesso!' });
        setShowRegisterModal(false);
      }}
    />

    </>
  );
};

export default Clientes; 